// Device-token client for the TV player. Uses ONLY the scoped `wwd_` device token.
// The token is stored in localStorage, sent ONLY in the Authorization header, and is
// NEVER placed in a URL/query string, logged, or sent to analytics.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/device`;
const TOKEN_KEY = "ww_device_token";
const DEVICE_ID_KEY = "ww_device_id";

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredDeviceId = () => localStorage.getItem(DEVICE_ID_KEY);

export function storeCredentials(token, deviceId) {
  localStorage.setItem(TOKEN_KEY, token);
  if (deviceId) localStorage.setItem(DEVICE_ID_KEY, deviceId);
}

export function clearCredentials() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(DEVICE_ID_KEY);
}

async function raw(path, { method = "GET", body, token } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

// Unauthenticated pairing (device side). device_code stays in memory only.
export const pairStart = (payload) => raw("/pair/start", { method: "POST", body: payload });
export const pairPoll = (device_code) => raw("/pair/poll", { method: "POST", body: { device_code } });

// Device-token authenticated Player API. Callers must clear credentials on 401/403.
export const deviceConfig = (token) => raw("/config", { token });
export const deviceNext = (token, { variant = "auto", px } = {}) =>
  raw(`/next?variant=${encodeURIComponent(variant)}${px ? `&physical_long_edge_px=${px}` : ""}`, { token });
export const deviceHeartbeat = (token) => raw("/heartbeat", { method: "POST", token });
